//const baseUrl = 'http://1.117.192.214:8081';
export const baseUrl = 'https://m.hzmed.top/api';
//export const baseUrl = 'http://8.155.44.234:8081';
import {get, post} from './HttpUtils'

/* 接口地址： */
//登陆
export const login = (params) => post(baseUrl + "/login", params)
//// 获取全部服务公司信息
export const getServiceCompanys = (params) => get(baseUrl + "/sourceCode/serviceCo mpany/getServiceCompanys", params)

export const deliverGood = (params) => post(baseUrl + "/sourceCode/code/deliverGood", params)

export const search = (params) => get(baseUrl + "/sourceCode/code/search", params)
export const eeaaa = (params) => get(baseUrl + "/sourceCode/code/search", params)

// export const doctor = (params) => get(baseUrl + "/doctor/list", params)
export const hospital = (params) => get(baseUrl + "/doctor/queryDoctorList", params)

 // export const hospitallist = (params) => get(baseUrl + "/hospital/list", params)
 export const hospitallist = (params) => get(baseUrl + "/hospital/queryHospitalList", params)
 export const doctor = (params) => get(baseUrl + "/doctor/queryScDoctorList", params)

export const queryByType = (params) => get(baseUrl + "/sourceCode/categorypic/queryByType", params)
/*
使用方法 ：
1.在要使用的js文件导入
const API = require('../../../../http/APICongfig.js');
const API = require('@http/APIConfig.js');

2. 调用
API.getPageArrDic(params).then(res => {

}).catch(error => {

});

 */